export const detectBenefitTypeIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /* ----------------------------------
     * DELETE benefit type (natural language)
     * ---------------------------------- */
    const deleteRegex =
        /(delete|remove|erase|drop|get rid of)\s+(the\s+)?(benefit type)?\s*(named|called|for)?\s*(.+)?/;

    const deleteMatch = cleaned.match(deleteRegex);

    if (
        deleteMatch &&
        cleaned.includes("benefit") &&
        cleaned.includes("type")
    ) {
        return {
            intent: "delete_benefit_type",
            name: deleteMatch[5]?.trim() || undefined
        };
    }

    /* ----------------------------------
     * CREATE benefit type (natural language)
     * ---------------------------------- */
    const createRegex =
        /(create|add|make|setup|set up|configure|define)\s+(a\s+|new\s+)?(benefit type)?\s*(named|called|for)?\s*(.+)?/;

    const createMatch = cleaned.match(createRegex);

    if (
        createMatch &&
        cleaned.includes("benefit") &&
        cleaned.includes("type")
    ) {
        return {
            intent: "create_benefit_type",
            name: createMatch[5]?.trim() || undefined
        };
    }

    return null;
};
